export default __webpack_public_path__ + "5bd603b670d69bcdeeab278424b494b2.svg";